import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

/**
 * Busca de pessoa por nome ou documento, para campos de seleção.
 *
 * Existe em um lugar só porque três telas precisam da mesma coisa (pedido de
 * compra, contas a pagar, contas a receber) e a alternativa era cada uma
 * digitar UUID a mão — que era exatamente o estado anterior.
 *
 * `type` filtra no servidor (`PartyType`). Sem ele, a busca de fornecedor
 * traria clientes e o operador escolheria um cliente como fornecedor sem
 * perceber.
 */

export interface PartyOption {
  id: string;
  name: string;
  documentNumber?: string;
  email?: string;
  phone?: string;
  mobile?: string;
}

function usePartyLookup(search: string, type: string) {
  return useQuery({
    queryKey: ['lookup', 'parties', type, search],
    queryFn: () =>
      apiClient.get<{ data: PartyOption[] }>('/parties', {
        params: { search, type, limit: '10' },
      }),
    enabled: search.trim().length >= 2,
  });
}

export function useSupplierLookup(search: string) {
  return usePartyLookup(search, 'SUPPLIER');
}

export function useCustomerLookup(search: string) {
  return usePartyLookup(search, 'CUSTOMER');
}

/** Produto por nome ou SKU. `GET /products` devolve array puro. */
export function useProductLookup(search: string) {
  return useQuery({
    queryKey: ['lookup', 'products', search],
    queryFn: () =>
      apiClient.get<{ id: string; sku: string; name: string; unit?: string }[]>('/products', {
        params: { search, limit: '10' },
      }),
    enabled: search.trim().length >= 2,
  });
}
